import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ViewFileComponent } from '@nibras/common-components/view-file';
import { ConnectionResolver } from '@nibras/core';
import { SelectivePreloadingStrategy } from '@nibras/core/common';

export const appRoutes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('@nibras/login').then(m => m.LoginModule)
  },
  {
    path: 'viewFile/:fileGUID/:download',
    component: ViewFileComponent,
    resolve: { connection: ConnectionResolver }
  },
  {
    path: 'not-found',
    loadChildren: () => import('@nibras/not-found').then(m => m.NotFoundModule)
  },
  {
    path: '',
    loadChildren: () => import('./lib-loader/lib-loader.module').then(m => m.LibLoaderModule),
    data: { preload: true },
    //canActivate: [AuthGuard],
    resolve: { connection: ConnectionResolver }
  },
  { path: '**', redirectTo: 'not-found' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      enableTracing: false,
      preloadingStrategy: SelectivePreloadingStrategy
    })
  ],
  providers: [SelectivePreloadingStrategy],
  exports: [RouterModule]
})
export class AppRoutingModule {}
